module.exports = __webpack_public_path__ + "img/avatar5.e66f4868.png";